// @ts-nocheck
import React, { useState, useEffect } from 'react';
import {
  DraggableCircle,
  GaugeContainer,
  GaugeSvg,
  Input,
  InputLabel,
  InputWrapper,
  ComplementInput,
  FakeInput,
} from './styles';

type CurvedSliderProps = {
  handleChangeValue: (value: number | string) => void;
  fuelLevelValue: number | string | undefined;
  isError: boolean;
};

const CurvedSlider: React.FC<CurvedSliderProps> = ({
  handleChangeValue,
  fuelLevelValue,
  isError,
}) => {
  const [value, setValue] = useState(0);
  const [dragging, setDragging] = useState(false);

  const handleInputChange = (e): void => {
    const newValue = Math.min(Math.max(Math.round(e.target.value), 0), 80);
    setValue(newValue);
    handleChangeValue(newValue);
  };

  const handleMouseDown = (e): void => {
    e.preventDefault();
    setDragging(true);
  };

  const handleMouseUp = (): void => {
    setDragging(false);
  };

  const handleMouseMove = (e): void => {
    if (dragging) {
      const svg = document.getElementById('gauge-svg');
      const rect = svg.getBoundingClientRect();
      const x = e.clientX - rect.left;
      let newValue = Math.round((x / rect.width) * 80);
      newValue = Math.min(Math.max(newValue, 0), 80);
      setValue(newValue);
      handleChangeValue(newValue);
    }
  };

  useEffect(() => {
    const handleMouseMoveWrapper = (e): void => {
      if (dragging) {
        handleMouseMove(e);
      }
    };

    if (dragging) {
      window.addEventListener('mousemove', handleMouseMoveWrapper);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMoveWrapper);
      window.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMoveWrapper);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging]);

  const getCoordinates = (val: number): { cx: number; cy: number } => {
    switch (true) {
      case val >= 0 && val <= 4:
        return { cx: 1, cy: 120 };
      case val >= 5 && val <= 9:
        return { cx: 9, cy: 102 };
      case val >= 10 && val <= 14:
        return { cx: 16, cy: 85 };
      case val >= 15 && val <= 19:
        return { cx: 24.5, cy: 67.5 };
      case val >= 20 && val <= 24:
        return { cx: 35, cy: 50 };
      case val >= 25 && val <= 29:
        return { cx: 53.75, cy: 32.75 };
      case val >= 30 && val <= 34:
        return { cx: 72.5, cy: 21.75 };
      case val >= 35 && val <= 39:
        return { cx: 91.25, cy: 10.25 };
      case val >= 40 && val <= 44:
        return { cx: 110, cy: 5 };
      case val >= 45 && val <= 49:
        return { cx: 130, cy: -1.5 };
      case val >= 50 && val <= 54:
        return { cx: 150, cy: 0 };
      case val >= 55 && val <= 59:
        return { cx: 170, cy: 2.5 };
      case val >= 60 && val <= 64:
        return { cx: 190, cy: 8 };
      case val >= 65 && val <= 69:
        return { cx: 233, cy: 32.5 };
      case val >= 70 && val <= 74:
        return { cx: 258, cy: 60 };
      case val >= 75 && val <= 79:
        return { cx: 272, cy: 90 };
      case val === 80:
        return { cx: 280, cy: 120 };
      default:
        return { cx: 1, cy: 120 };
    }
  };

  const { cx, cy } = getCoordinates(value);

  useEffect(() => {
    if (fuelLevelValue !== value) {
      setValue(Number(fuelLevelValue));
    }
  }, [fuelLevelValue, value]);

  return (
    <GaugeContainer>
      <GaugeSvg
        id="gauge-svg"
        viewBox="0 0 280 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M256.064 137.134H222.508C217.014 137.134 212.379 133.076 211.614 127.636C210.039 116.413 205.712 106.071 199.34 97.3164L244.098 64.7979C256.65 82.0445 264.83 102.674 267.009 125.066C267.638 131.535 262.561 137.139 256.061 137.139L256.064 137.134Z"
          fill="#17C36B"
        />
        <path
          d="M244.097 64.7951L199.339 97.3137C191.02 85.8782 179.208 77.1486 165.469 72.6889L182.568 20.062C207.522 28.1654 228.979 44.0238 244.095 64.7923L244.097 64.7951Z"
          fill="#9CCF40"
        />
        <path
          d="M123.593 72.689C109.856 77.1487 98.0442 85.8811 89.7254 97.3138L44.9668 64.7952C60.0828 44.0267 81.5399 28.1655 106.493 20.0649L123.593 72.689Z"
          fill="#EB9632"
        />
        <path
          d="M89.7248 97.3137C83.3497 106.069 79.026 116.411 77.4506 127.634C76.6885 133.074 72.0531 137.131 66.5564 137.131H33.0008C26.5039 137.131 21.4237 131.527 22.0527 125.058C24.2316 102.669 32.4115 82.0362 44.9633 64.7896L89.7219 97.3081L89.7248 97.3137Z"
          fill="#E23E44"
        />
        <path
          d="M182.572 20.062L165.473 72.6889C158.879 70.5497 151.841 69.3909 144.534 69.3909C137.227 69.3909 130.189 70.5469 123.595 72.6889L106.496 20.0648C118.473 16.1746 131.257 14.0723 144.534 14.0723C157.811 14.0723 170.592 16.1746 182.572 20.062Z"
          fill="#EDBE00"
        />
        <path
          d="M251.758 60.751C265.923 80.7262 275.154 104.62 277.613 130.554"
          stroke="#17C36B"
          strokeWidth="2.19502"
        />
        <path
          d="M251.757 60.7478L251.754 60.7445C234.695 36.6902 210.479 18.3229 182.318 8.9375"
          stroke="#9CCF40"
          strokeWidth="2.19502"
        />
        <path
          d="M27.0293 60.7474C44.0884 36.6931 68.3036 18.3226 96.4646 8.94043"
          stroke="#EB9632"
          strokeWidth="2.19502"
        />
        <path
          d="M1.16992 130.545C3.62886 104.613 12.8602 80.7164 27.0255 60.7412"
          stroke="#E23E44"
          strokeWidth="2.19502"
        />
        <path
          d="M182.322 8.93735C168.802 4.43496 154.378 2 139.394 2C124.41 2 109.983 4.43496 96.4668 8.94063"
          stroke="#EDBE00"
          strokeWidth="2.19502"
        />
        <DraggableCircle
          cx={cx}
          cy={cy}
          r="12"
          fill="#0B29FB"
          stroke="white"
          strokeWidth="1.09751"
          onMouseDown={handleMouseDown}
        />
      </GaugeSvg>
      <InputWrapper isError={isError}>
        <InputLabel>Nível do gás</InputLabel>
        {fuelLevelValue === undefined ? (
          <FakeInput
            onClick={() => {
              handleChangeValue(0);
              setValue(0);
            }}
          >
            Digite aqui
          </FakeInput>
        ) : (
          <Input
            type="number"
            value={value}
            onChange={handleInputChange}
            min="0"
            max="80"
          />
        )}
        <ComplementInput>%</ComplementInput>
      </InputWrapper>
    </GaugeContainer>
  );
};

export default CurvedSlider;
